module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA3klEQVRYR8XX0QkCMQwGYOMaBcHFhNvBLW4IwUlcJtAlepEeCiJik/wJvede/695SBs6TP4oIl9Ejn0fItqs+8GAHs7Mtx5cSlmsCAjwEX55nfxuRUAAZl5F5PpVdhMCAtRaz621h4icvAgI0ENRBAxAESEABBEG8CJCAR5EOMCKSAFYEGkALSIVoEJYby/P+n/NKr0CoyqkA4at2lNS7T/DcKItrQKa8P0VpT2NZZ02PAVgCQ8HWMNDAZ7wMIA3PASAhMMANBwGTH+WTx9Megmnjmbv7jh1OLW06F9rn51CPsg+NE0iAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left.png
// module id = F0Yv
// module chunks = 1